import React from 'react';
import PopupCancelReceipt from '../PopupCancelReceipt'

export function CancelReceiptColumnFormatter(cellContent, intl, dispatch) {

  return (
    <PopupCancelReceipt
      cellContent={cellContent}
      intl={intl}
      dispatch={dispatch}
    />
  )
}
